const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };
  window.recommendFlow = {
    currentVariantId: null,
}

var productTab = [];

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      // Custom code for product page goes here
      this.productZoom();
      if(document.querySelector('[data-review-scroll]')){        
        document.querySelector('[data-review-scroll]').addEventListener('click', (e) => {
          e.stopImmediatePropagation();
          const offsetTop = document.querySelector("#review__list").offsetTop;
          scroll({
            top: offsetTop - 30,
            behavior: "smooth"
          });
        });
      }

      //california state display the message based on the tag and session value
      const getStoredRegion = Utility.getCookie("region-is-detected");
      if (getStoredRegion == 'gujarat' || getStoredRegion == 'maharashtra' || getStoredRegion == 'federation of b&h' || getStoredRegion == 'california') {
        
        const calMessage = document.querySelector(".california-msg");
        if (calMessage) {
          calMessage.classList.remove('d-none');
          if (calMessage) {
            const message = calMessage.getAttribute("data-custom-msg");
            calMessage.querySelector('p').textContent = message;
          }
        }
      }

      if( document.querySelectorAll("[data-open-notify]").length > 0){
        document.querySelectorAll("[data-open-notify]").forEach(ele=>{
          ele.addEventListener("click", (event)=>{
            this._openBackInStock();
          })
        })
      }

    if(document.querySelectorAll("[data-recomand-product-option]").length > 0){
      document.querySelectorAll("[data-recomand-product-option]").forEach(ele=>{
          ele.addEventListener("change" , (event)=>{
              this._changeRecommendVariant(event);
          });
      });
    }

     if( document.querySelectorAll("[data-recommend-add]").length > 0){
        document.querySelectorAll("[data-recommend-add]").forEach(ele=>{
            ele.addEventListener("click" , (event)=>{
                event.preventDefault()
                this._addRecommendProduct(event);
            })
        })
     }
     let w = window.innerWidth;
     if (w < 768) {
       document.querySelectorAll("[data-product-tab]").forEach((contentBlock,i)=>{
        
        let Height = '280';
        let contentBlockHeight, eleType;
        if(contentBlock.closest('.tabcontent.open')){
          contentBlockHeight = contentBlock.offsetHeight;        
          contentBlock.style.height = Height + 'px';
          eleType = contentBlock.getAttribute('data-product-tab');
        } else {
          contentBlock.closest('.tabcontent').classList.add('open');
          contentBlockHeight = contentBlock.offsetHeight;        
          contentBlock.style.height = Height + 'px';
          eleType = contentBlock.getAttribute('data-product-tab');
          productTab.push({eleType,contentBlockHeight});
          contentBlock.closest('.tabcontent').classList.remove('open');
        }

        productTab.push({eleType,contentBlockHeight});
       
         if (i != 0) {
          contentBlock.closest(".tabcontent").classList.remove("open");
         }
      });

      document.querySelectorAll("[data-show-tab]").forEach(ele=>{
          ele.addEventListener("click", (event)=>{
              this.toggleContentBlock(event);
          })
        });
      }
    }

    toggleContentBlock(e){
      e.preventDefault();
      let ele = e.currentTarget;
      let tabName =  ele.getAttribute("data-show-tab");
      let contentBlockHeight =  productTab.find(x => tabName == x.eleType);
      contentBlockHeight =contentBlockHeight.contentBlockHeight;
      let currentTarget = e.target;
      let contentBlock = currentTarget.closest(".product-block-desc");
      contentBlock = contentBlock.querySelector("[data-product-tab]");
      let Height = '280';
      contentBlock.style.height = Height + 'px';
      if (currentTarget.closest('.product-block-desc').querySelector('.product-description-short').classList.contains('open')){
        contentBlock.classList.remove('open');
        contentBlock.style.height = Height + 'px';
        currentTarget.innerHTML = 'Show more';
    } else {
        contentBlock.classList.add('open');
        contentBlock.style.height = contentBlockHeight + 'px';
        currentTarget.innerHTML = 'Show less';
    }

    }

    _openBackInStock(){
      const checkForKlaviyoLink = setInterval(function() {
        const klaviyoLink = document.querySelector('#product-form-installment .klaviyo-bis-trigger');
        if (klaviyoLink) {
          clearInterval(checkForKlaviyoLink);
          klaviyoLink.click();
        }
      }, 500);
    }

    _changeRecommendVariant(event){
      let recommendPrice = null;
      let currentElement = event.currentTarget;
      window.recommendFlow.currentVariantId = currentElement.value;
      let parentEle = currentElement.closest("[data-recommend-wrap]");
      parentEle.querySelector("[data-recommend-variant-id]").setAttribute("data-recommend-variant-id" , window.recommendFlow.currentVariantId );
      let options = currentElement.options;
      for (i = 0; i < options.length; i++) {
          if (options[i].value == window.recommendFlow.currentVariantId) {
          recommendPrice =  options[i].getAttribute("data-recommend-price");
          parentEle.querySelector("[data-recommend-price]").innerHTML = recommendPrice;
          };
       }
  };

  _addRecommendProduct(event){
      let currentEle = event.currentTarget;
      var items= [];
       window.recommendFlow.currentVariantId = currentEle.getAttribute("data-recommend-variant-id");
       items.push({
          quantity: 1,
          id: parseInt(window.recommendFlow.currentVariantId)
      });
      var requestData = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({items: items}),
      };
      fetch('/cart/add.js', requestData)
      .then(async data => {
          let cartElement = document.querySelector('ajax-cart');
          let cartData= cartElement.getCartData('open_drawer');
         
          // document.querySelector("[data-count-cart-items]").innerHTML = window.globalVariables.cart.item_count;
          
      }).catch(e => {
          console.log(e);
      });
  }

  productZoom() {
    if (window.innerWidth >= 768) {
        var selectedImage = document.querySelectorAll('.product--media img');
        var zoomWrapper = document.querySelector('.product-zoom-container');
        setTimeout(() => {
            selectedImage.forEach((item) => {
                new Drift(item, {
                    paneContainer: zoomWrapper,
                    inlinePane: 900,
                    inlineOffsetY: -85,
                    containInline: true,
                    hoverBoundingBox: true,
                });
                item.style.cursor = 'crosshair';
            })
        }, 3000);   
    }
}
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();


// document.querySelectorAll('.product-block-desc .block_show').forEach((ele) => {
//   ele.addEventListener('click', (event) => {
//     event.preventDefault();
//     const currentEle = event.currentTarget;
//     const getBlockNo = currentEle.getAttribute("data-block");
   
//     document.querySelector(`.product-description-full[data-block="`+ getBlockNo +`"]`).classList.remove("d-none");
//     document.querySelector(`.product-description-short[data-block="`+ getBlockNo +`"]`).classList.add("d-none");
//   });
// });

// document.querySelectorAll('.product-block-desc .block_hide').forEach((ele) => {
//   ele.addEventListener('click', (event) => {
//     event.preventDefault();
//     const currentEle = event.currentTarget;
//     const getBlockNo = currentEle.getAttribute("data-block");
  
//     document.querySelector(`.product-description-full[data-block="`+ getBlockNo +`"]`).classList.add("d-none");
//     document.querySelector(`.product-description-short[data-block="`+ getBlockNo +`"]`).classList.remove("d-none");
//   });
// });